import { useQuery } from "@tanstack/react-query";
import { DropsApi } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useGetDropTwitchVods(slug?: string) {
    return useQuery({
        queryKey: ["drop-twitch-vods", slug],
        queryFn: async () => {
            if (!slug) return null;
            const api = new DropsApi(getConfig());
            return (api as any).getDropsSlugSlugContentTwitchVods({ slug });
        },
        enabled: Boolean(slug),
        staleTime: 15 * 60 * 1000,
    });
}
